import React, { useState, useRef, Fragment } from 'react';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Bottom } from "../Common/Header";
import UserService from "../../services/user.service";
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationIcon } from '@heroicons/react/outline'
import ReCAPTCHA from 'react-google-recaptcha'

const required = (value) => {
	if(!value) {
		return(
			<div className="alert alert-danger" role="alert">
				Este campo es requerido!
			</div>
		)
	}
}

const ValidaQr = (props) => {	
	const form = useRef();
	const checkBtn = useRef();
	let { code } = useParams();

	const [certificate, setCertificate] = useState("");	
	const [successful, setSuccessful] = useState(false);
  	const [message, setMessage] = useState("");
  	const [loading, setLoading] = useState(false);
  	const recaptcha = useRef();
  	const [isCodeOk, setIsCodeOk] = useState(false);	

	let navigate = useNavigate();	 

	const handleCode = (e) => {
		e.preventDefault();

		const captchaValue = recaptcha.current.getValue()
	   if (!captchaValue) {
	   	alert('Valida el CAPTCHA.')
	   } else {
	   	// make form submission
	      setMessage("");
			setSuccessful(false);
			setLoading(true);

			form.current.validateAll();

			if(checkBtn.current.context._errors.length === 0) {
				UserService.checkQr(code)
				.then(
					(response) => {
						let cerdata = response.data.certificate;            	
	            	setCertificate({ name: cerdata.name, business_name: cerdata.business_name, for_date: cerdata.for_date });
						setMessage("Código válido.");						
						setSuccessful(true);
						setLoading(false);
						setIsCodeOk(true);
					},
					(error) => {
						const resMessage = ( error.response && error.response.data && error.response.data.message)
											|| error.message || error.toString();

						setMessage(resMessage);
						setSuccessful(false);
						setLoading(false);
						setIsCodeOk(false);
					}
				);
			}else{
				setLoading(false);
			}
	   }		
	};

	const [open, setOpen] = useState(false)
  	const cancelButtonRef = useRef(null)

  	function formatDate(dt){
		if(dt){
			var d = new Date(dt.replace(/-/g, '\/').replace(/T.+/, ''));	//var d = new Date(dt);
			var datestring = d.getDate() + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
			return datestring;
		}
	};
	return(
		<div className="min-h-screen bg-gray-100 flex items-center justify-center bg-cover">

			<div className="flex flex-row bg-gray-100 rounded shadow-lg">
				<div className="login shadow p-4 bg-white rounded-l">
					<Form onSubmit={handleCode} ref={form} >
						<div className="flex flex-col">
							<div className="mb-4 flex flex-col justify-center text-center">
								<Link to="/"><img src="/img/bomberos-de-leon.png" alt="BDL" className="mx-auto" /></Link>
								<h2 className="text-xl mt-2 font-bold">Validar QR</h2>
							</div>											
							<div className="my-2">
								<ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
					      </div>
				         <div className="my-2">
				         	{loading && (
					         	<div className="w-full text-center">
						         	<svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
										   <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
										   <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
										</svg>
										<span className="sr-only">Loading...</span>
									</div>
								)}
								<p className="text-center text-xs py-2">{code}</p>
							  	<button type="submit" disabled={loading} className="w-full bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline">
					           	<span>Validar</span>					           	
					         </button>					         
				         </div>

				         {message && (
				         <div className="my-2 shadow ">
				        		<div className="p-2 text-center text-gray-800 font-bold text-lg flex items-center justify-center gap-4" style={isCodeOk ? styles.codeOk : styles.codeNo}>
				            	{message}
				            	{isCodeOk ?
					            	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="h-8">
										  <path strokeLinecap="round" strokeLinejoin="round" d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z" />
										</svg>
										:
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="h-8">
										  <path strokeLinecap="round" strokeLinejoin="round" d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54" />
										</svg>
									}

				            </div>
				            {isCodeOk &&
				            <div className="p-2 text-center text-black text-base">
				            	<p><span className="">Nombre:</span> {certificate.name}</p>
				            	<p><span className="">Empresa:</span> {certificate.business_name}</p>
				            	<p><span className="">Fecha:</span> {formatDate(certificate.for_date)}</p>
				            </div>
				         	}
				         </div>
				         )}				         
				      	<CheckButton style={{ style: 'none' }} ref={checkBtn} />
				   	</div>
			   	</Form>
			   </div>
		   </div>
			
			<Bottom />

		</div>
	);
};


export default ValidaQr;

const styles = {
   codeOk: {
   	backgroundColor: '#00ae3412',
   	color: '#00ae34',
   },
   codeNo:
   {
   	backgroundColor: '#fffdf2',
   	color: '#877400',
   },
};